// ============================================
// BELT SYSTEM — Full IBJJF kids + adult belts
// ============================================

export const KIDS_BELTS = [
  {
    n: 'White', th: 'wht', short: 'White',
    a1: '#f0f0f0', a2: '#b8b8b8',
    bg: 'linear-gradient(155deg,#ffffff 0%,#f0f0f0 40%,#ffffff 60%,#e8e8e8 100%)',
    border: '#d0d0d0', color: '#1a1a1a',
    sessionsToLevel10: 60, ovrFloor: 1, ovrThreshold: 8,
  },
  {
    n: 'White/Grey', th: 'wht_gry', short: 'W/Grey',
    a1: '#d8d8d8', a2: '#686868',
    bg: 'linear-gradient(155deg,#e8e8e8 0%,#888888 35%,#d0d0d0 55%,#505050 100%)',
    border: '#909090', color: '#fff',
    sessionsToLevel10: 40, ovrFloor: 8, ovrThreshold: 13,
  },
  {
    n: 'Grey', th: 'gry', short: 'Grey',
    a1: '#a8a8a8', a2: '#484848',
    bg: 'linear-gradient(155deg,#b0b0b0 0%,#686868 40%,#c0c0c0 60%,#484848 100%)',
    border: '#808080', color: '#fff',
    sessionsToLevel10: 80, ovrFloor: 13, ovrThreshold: 20,
  },
  {
    n: 'Black/Grey', th: 'blk_gry', short: 'B/Grey',
    a1: '#505050', a2: '#181818',
    bg: 'linear-gradient(155deg,#484848 0%,#101010 35%,#585858 55%,#080808 100%)',
    border: '#606060', color: '#d0d0d0',
    sessionsToLevel10: 40, ovrFloor: 20, ovrThreshold: 25,
  },
  {
    n: 'White/Yellow', th: 'wht_yel', short: 'W/Yellow',
    a1: '#e8d840', a2: '#b09000',
    bg: 'linear-gradient(155deg,#ffee22 0%,#ddcc00 35%,#ffee44 55%,#ccbb00 100%)',
    border: '#ddcc00', color: '#ffffff',
    sessionsToLevel10: 40, ovrFloor: 25, ovrThreshold: 30,
  },
  {
    n: 'Yellow', th: 'yel', short: 'Yellow',
    a1: '#d4a818', a2: '#785800',
    bg: 'linear-gradient(155deg,#f0cc30 0%,#b07800 40%,#f8e040 60%,#886000 100%)',
    border: '#c89010', color: '#3a1800',
    sessionsToLevel10: 80, ovrFloor: 30, ovrThreshold: 37,
  },
  {
    n: 'Black/Yellow', th: 'blk_yel', short: 'B/Yellow',
    a1: '#906800', a2: '#302000',
    bg: 'linear-gradient(155deg,#705000 0%,#201000 35%,#907000 55%,#181000 100%)',
    border: '#c8a030', color: '#f0c840',
    sessionsToLevel10: 40, ovrFloor: 37, ovrThreshold: 42,
  },
  {
    n: 'White/Orange', th: 'wht_ora', short: 'W/Orange',
    a1: '#e87838', a2: '#903000',
    bg: 'linear-gradient(155deg,#f08840 0%,#a04000 35%,#f09050 55%,#782800 100%)',
    border: '#c05010', color: '#fff',
    sessionsToLevel10: 40, ovrFloor: 42, ovrThreshold: 47,
  },
  {
    n: 'Orange', th: 'ora', short: 'Orange',
    a1: '#c86028', a2: '#702000',
    bg: 'linear-gradient(155deg,#e87030 0%,#a03800 40%,#f08040 60%,#782800 100%)',
    border: '#c04808', color: '#fff',
    sessionsToLevel10: 80, ovrFloor: 47, ovrThreshold: 53,
  },
  {
    n: 'Black/Orange', th: 'blk_ora', short: 'B/Orange',
    a1: '#703010', a2: '#200800',
    bg: 'linear-gradient(155deg,#602808 0%,#180400 35%,#703010 55%,#100200 100%)',
    border: '#c04808', color: '#f08040',
    sessionsToLevel10: 40, ovrFloor: 53, ovrThreshold: 57,
  },
  {
    n: 'White/Green', th: 'wht_grn', short: 'W/Green',
    a1: '#58a858', a2: '#285828',
    bg: 'linear-gradient(155deg,#70c070 0%,#308030 35%,#68b868 55%,#206020 100%)',
    border: '#308028', color: '#fff',
    sessionsToLevel10: 40, ovrFloor: 57, ovrThreshold: 61,
  },
  {
    n: 'Green', th: 'grn', short: 'Green',
    a1: '#389038', a2: '#184818',
    bg: 'linear-gradient(155deg,#58aa58 0%,#206020 40%,#68b868 60%,#184018 100%)',
    border: '#308028', color: '#fff',
    sessionsToLevel10: 80, ovrFloor: 61, ovrThreshold: 65,
  },
  {
    n: 'Black/Green', th: 'blk_grn', short: 'B/Green',
    a1: '#184818', a2: '#040804',
    bg: 'linear-gradient(155deg,#103010 0%,#020402 35%,#204020 55%,#010201 100%)',
    border: '#308028', color: '#60c060',
    sessionsToLevel10: 40, ovrFloor: 65, ovrThreshold: 68,
  },
]

export const ADULT_BELTS = [
  {
    n: 'White', th: 'wht', short: 'White',
    a1: '#f0f0f0', a2: '#b8b8b8',
    bg: 'linear-gradient(155deg,#ffffff 0%,#f0f0f0 40%,#ffffff 60%,#e8e8e8 100%)',
    border: '#d0d0d0', color: '#1a1a1a',
    sessionsToLevel10: 100, ovrFloor: 1, ovrThreshold: 20,
  },
  {
    n: 'Blue', th: 'blu', short: 'Blue',
    a1: '#2878c8', a2: '#084070',
    bg: 'linear-gradient(155deg,#3888d0 0%,#0c4888 40%,#48a0e0 60%,#082868 100%)',
    border: '#1860a8', color: '#fff',
    sessionsToLevel10: 200, ovrFloor: 20, ovrThreshold: 45,
  },
  {
    n: 'Purple', th: 'pur', short: 'Purple',
    a1: '#7060d0', a2: '#2c1880',
    bg: 'linear-gradient(155deg,#8070e0 0%,#3c30a0 40%,#9080f0 60%,#281878 100%)',
    border: '#5040b8', color: '#fff',
    sessionsToLevel10: 300, ovrFloor: 45, ovrThreshold: 65,
  },
  {
    n: 'Brown', th: 'brn', short: 'Brown',
    a1: '#9a6030', a2: '#481800',
    bg: 'linear-gradient(155deg,#aa6830 0%,#603010 40%,#c07840 60%,#401800 100%)',
    border: '#7a4818', color: '#fff',
    sessionsToLevel10: 300, ovrFloor: 65, ovrThreshold: 80,
  },
  {
    n: 'Black', th: 'blk', short: 'Black',
    a1: '#303030', a2: '#080808',
    bg: 'linear-gradient(155deg,#303030 0%,#0a0a0a 40%,#404040 60%,#080808 100%)',
    border: '#c8a030', color: '#e8c840',
    sessionsToLevel10: 400, ovrFloor: 80, ovrThreshold: 99,
  },
]

// Champion card theme (2+ gold medals)
export const CHAMPION_THEME = {
  bg: 'linear-gradient(155deg,#fff080 0%,#e8a000 20%,#fffaa0 45%,#c07800 70%,#f8d830 100%)',
  border: '#f0c010', color: '#3a1800',
}

// Level thresholds — how many sessions at current belt needed per level
// Uses exponential curve so early levels are fast, later levels take longer
export function sessionsForLevel(belt, targetLevel) {
  if (targetLevel <= 1) return 0
  const total = belt.sessionsToLevel10
  // Exponential distribution: each level takes progressively more sessions
  const weights = [0, 0.04, 0.06, 0.08, 0.10, 0.12, 0.13, 0.14, 0.14, 0.19]
  let sum = 0
  for (let i = 0; i < targetLevel - 1; i++) sum += weights[i] * total
  return Math.round(sum)
}

export function calcBeltLevel(belt, beltSessions) {
  for (let level = 10; level >= 1; level--) {
    if (beltSessions >= sessionsForLevel(belt, level)) return level
  }
  return 1
}

export function calcLevelProgress(belt, beltSessions) {
  const level = calcBeltLevel(belt, beltSessions)
  if (level >= 10) return 1
  const currentThreshold = sessionsForLevel(belt, level)
  const nextThreshold = sessionsForLevel(belt, level + 1)
  return (beltSessions - currentThreshold) / (nextThreshold - currentThreshold)
}

export function sessionsToNextLevel(belt, beltSessions) {
  const level = calcBeltLevel(belt, beltSessions)
  if (level >= 10) return 0
  return sessionsForLevel(belt, level + 1) - beltSessions
}

// ============================================
// OVR CALCULATION
// ============================================

export function calcOVR(fighter, skills, competitions) {
  const belts = fighter.type === 'kids' ? KIDS_BELTS : ADULT_BELTS
  const belt = belts[fighter.belt_index] || belts[0]
  const beltSessions = fighter.belt_sessions || 0

  // Level component (0-1)
  const level = calcBeltLevel(belt, beltSessions)
  const levelProgress = calcLevelProgress(belt, beltSessions)
  const levelComponent = ((level - 1) + levelProgress) / 10

  // Skill component (0-1) — average of all technique stars / 10
  const skillAvg = skills && skills.length
    ? skills.reduce((s, x) => s + (x.stars || 0), 0) / skills.length / 10
    : 0

  // Competition component (0-1)
  const fighterComps = competitions
    ? competitions.filter(c => c.fighter_id === fighter.id)
    : []
  const compPoints = fighterComps.reduce((sum, c) => {
    if (c.medal === 'gold') return sum + 35
    if (c.medal === 'silver') return sum + 20
    if (c.medal === 'bronze') return sum + 10
    return sum + 5
  }, 0)
  const compComponent = Math.min(1, compPoints / 200)

  // Weighted score within belt range
  const rawScore = (levelComponent * 0.60) + (skillAvg * 0.30) + (compComponent * 0.10)
  const rangeScore = belt.ovrFloor + rawScore * (belt.ovrThreshold - belt.ovrFloor)

  // OVR never goes below previous max (carried forward)
  const previousMax = fighter.ovr_max || 0
  return Math.max(previousMax, Math.min(99, Math.round(rangeScore)))
}

export function isPromotionReady(fighter, skills, competitions) {
  const belts = fighter.type === 'kids' ? KIDS_BELTS : ADULT_BELTS
  const belt = belts[fighter.belt_index] || belts[0]
  const level = calcBeltLevel(belt, fighter.belt_sessions || 0)
  const ovr = calcOVR(fighter, skills, competitions)
  return level >= 10 && ovr >= belt.ovrThreshold
}

// ============================================
// FRONT STATS — 5 key category scores
// ============================================
export const FRONT_STAT_KEYS = [
  { label: 'TKD', cat: 'Takedowns' },
  { label: 'GRD', cat: 'Guard' },
  { label: 'PAS', cat: 'Passing' },
  { label: 'SUB', cat: 'Submissions' },
]

export const DEFAULT_SKILL_CATEGORIES = [
  { name: 'Takedowns', techniques: ['Double leg', 'Single leg', 'Hip throw', 'Foot sweep', 'Ankle pick', 'Body lock'] },
  { name: 'Guard', techniques: ['Closed guard', 'Open guard', 'Spider guard', 'Butterfly guard', 'De la Riva', 'X-guard', 'Half guard', 'Rubber guard'] },
  { name: 'Passing', techniques: ['Torreando', 'Over-under', 'Knee slice', 'Leg drag', 'Stack pass', 'Smash pass', 'Headquarters', 'Bullfighter'] },
  { name: 'Submissions', techniques: ['Rear naked choke', 'Armbar', 'Triangle', 'Guillotine', 'Kimura', 'Americana', 'Heel hook', 'Bow & arrow', 'D\'arce choke', 'Ezekiel'] },
  { name: 'Guard retention', techniques: ['Framing', 'Hip escape', 'Inversion', 'Granby roll'] },
  { name: 'Sweeps', techniques: ['Scissor sweep', 'Hip bump', 'Flower sweep', 'Pendulum', 'Elevator sweep'] },
  { name: 'Back control', techniques: ['Seat belt', 'Body triangle', 'Bow & arrow', 'RNC'] },
  { name: 'Wrestling', techniques: ['Sprawl', 'Underhook', 'Collar tie', 'Whizzer'] },
]

export const DAYS_OF_WEEK = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']

export const COUNTRIES = [
  { name: 'Croatia', code: 'HR' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Brazil', code: 'BR' },
  { name: 'USA', code: 'US' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Germany', code: 'DE' },
  { name: 'UK', code: 'GB' },
  { name: 'Japan', code: 'JP' },
  { name: 'Australia', code: 'AU' },
  { name: 'France', code: 'FR' },
  { name: 'Spain', code: 'ES' },
  { name: 'Italy', code: 'IT' },
]

export const SKINS = ['#f5c9a0','#e8b07a','#c8956a','#a87850','#8b5e3c','#fce0c0']
export const HAIRS = ['#2a1a0a','#1a1a1a','#8b4a10','#c8a050','#503020','#d4a060']
export const GIS   = ['#1a3a6a','#1a1a1a','#2a5a2a','#4a1a6a','#6a2a1a','#1a4a4a']
